import { Provider } from '@angular/core';

import { CreateJobService } from '../Domain/Port/CreateJob/create-job.service';
import { AnalyticsBackendCreateJobServiceDecorator } from '../Infrastructure/Adapter/CreateJob/analytics-create-job.service.decorator';

export const provideCreateJobService = (): Provider[] => {
    return [
        {
            provide: CreateJobService,
            useExisting: AnalyticsBackendCreateJobServiceDecorator
        }
    ];
};
